export default "__VITE_ASSET__DzLnS5aa__"